import React, { useEffect } from "react";
import { Switch } from "../ui/Icons";
import CircleBg from "../common/CircularBgProps";
import { NavLink } from "react-router-dom";
import GsapMagnetic from "../ui/GsapMagnetic";
import transtion from "../ui/Animation/transition.module.scss";
import { motion } from "framer-motion";
import { slide, transitionSlide } from "../ui/Animation/anim";
import AnimatedText from "../ui/Animation/AnimatedText";
import { navItems } from "../../utils/navItems";
import NavLinkStyle from "../common/NavigationLinkStyles";
import { MenuProps } from "../common/types";

const SideMenu: React.FC<MenuProps> = ({
  open,
  onClose,
  toggleTheme = () => {},
  isDarkMode,
}) => {
  // const overlayRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      const sideMenuElement = document.getElementById("sideMainMenu");
      const clickedElement = event.target as HTMLElement;

      // Check if the click was outside the overlay
      // if (
      //   overlayRef.current &&
      //   !overlayRef.current.contains(event.target as Node)
      // ) {
      //   onClose(); // Close the overlay
      // }

      // Check if the click is outside the side menu and not on any of the buttons
      if (
        sideMenuElement &&
        !sideMenuElement.contains(clickedElement) &&
        !clickedElement.classList.contains("menuSqMenuBtn") &&
        !clickedElement.classList.contains("menuCrlBtn")
      ) {
        onClose(); // Close the menu
      }
    }; 

    if (open) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [open, onClose]);

  return (
    <>
      <motion.div
        variants={transitionSlide}
        initial="initial"
        animate="enter"
        exit="exit"
        id="sideMainMenu"
        // ref={overlayRef}
        className={transtion.sideMenu}
      >
        <NavLinkStyle>
          <div className={transtion.navigateText}>
            <AnimatedText $animTextMargin="0 0 10px 0" text={"Navigate"} />
          </div>
          {navItems.map((data, index) => {
            return (
              <motion.div
                custom={index} //for each menu item to slide
                variants={slide}
                initial="initial"
                animate="enter"
                exit="exit"
                key={index}
              >
                <GsapMagnetic
                  key={index}
                  $maxTranslation={10}
                  $magneticOverflow="visible"
                >
                  <NavLink key={index} to={data.href} onClick={onClose}>
                    {data.title}
                  </NavLink>
                </GsapMagnetic>
              </motion.div>
            );
          })}
        </NavLinkStyle>

        <motion.div
          custom={navItems.length + 1}
          variants={slide}
          initial="initial"
          animate="enter"
          exit="exit"
          style={{ width: "76px" }}
        >
          <GsapMagnetic $maxTranslation={20} $magneticBorderRadius="50%">
            <CircleBg $circleBgSize="76px">
              <div className="imgPresent" style={{borderRadius: '20px'}}>
                <Switch
                  toggleTheme={toggleTheme}
                  isDarkMode={isDarkMode}
                  $marginLeft="0px"
                />
              </div>
            </CircleBg>
          </GsapMagnetic>
        </motion.div>
      </motion.div>
    </>
  );
};

export default React.memo(SideMenu);
